"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _layout = require("../../../layout");

var _responsive = require("../../../responsive");

var _text = require("../../../text");

var _utils = require("../../../utils");

var _utils2 = require("../../utils");

var _constants = require("../constants");

var _interfaces = require("../interfaces");

var _propTypes = require("../propTypes");

var _DatePickerGroup = _interopRequireDefault(require("./DatePickerGroup"));

var _PopupDatePickerContext = require("./PopupDatePickerContext");

var _helperComponents = require("./helperComponents");

var _propTypes2 = require("./propTypes");

var _core = require("@emotion/core");

var _excluded = ["startValue", "endValue", "defaultStartValue", "defaultEndValue", "layout", "id", "name", "disabled", "labelText", "startDateLabelText", "endDateLabelText", "showSelectedDaysText", "getSelectedDaysText", "onChange", "dateMarkerLegend", "popoverProps", "startDateInputProps", "endDateInputProps", "startDateInputFooter", "endDateInputFooter", "calendarButtonAltText", "renderPopupContent", "shouldCloseOnDateSelection", "collapsedTitleText", "collapsedCloseButtonAltText", "ariaLabelsForSelectedDate", "clearButtonAltText"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var PopupDateRangePickerWithoutDocs = function PopupDateRangePickerWithoutDocs(_ref) {
  var startValue = _ref.startValue,
      endValue = _ref.endValue,
      defaultStartValue = _ref.defaultStartValue,
      defaultEndValue = _ref.defaultEndValue,
      layout = _ref.layout,
      id = _ref.id,
      name = _ref.name,
      disabled = _ref.disabled,
      labelText = _ref.labelText,
      _ref$startDateLabelTe = _ref.startDateLabelText,
      startDateLabelText = _ref$startDateLabelTe === void 0 ? _constants.defaultPopupDateRangePickerProps.startDateLabelText : _ref$startDateLabelTe,
      _ref$endDateLabelText = _ref.endDateLabelText,
      endDateLabelText = _ref$endDateLabelText === void 0 ? _constants.defaultPopupDateRangePickerProps.endDateLabelText : _ref$endDateLabelText,
      _ref$showSelectedDays = _ref.showSelectedDaysText,
      showSelectedDaysText = _ref$showSelectedDays === void 0 ? _constants.defaultPopupDateRangePickerProps.showSelectedDaysText : _ref$showSelectedDays,
      _ref$getSelectedDaysT = _ref.getSelectedDaysText,
      getSelectedDaysText = _ref$getSelectedDaysT === void 0 ? _constants.defaultPopupDateRangePickerProps.getSelectedDaysText : _ref$getSelectedDaysT,
      onChange = _ref.onChange,
      dateMarkerLegend = _ref.dateMarkerLegend,
      _ref$popoverProps = _ref.popoverProps,
      popoverProps = _ref$popoverProps === void 0 ? _constants.defaultPopupDateRangePickerProps.popoverProps : _ref$popoverProps,
      _ref$startDateInputPr = _ref.startDateInputProps,
      startDateInputProps = _ref$startDateInputPr === void 0 ? _constants.defaultPopupDateRangePickerProps.inputProps : _ref$startDateInputPr,
      _ref$endDateInputProp = _ref.endDateInputProps,
      endDateInputProps = _ref$endDateInputProp === void 0 ? _constants.defaultPopupDateRangePickerProps.inputProps : _ref$endDateInputProp,
      startDateInputFooter = _ref.startDateInputFooter,
      endDateInputFooter = _ref.endDateInputFooter,
      _ref$calendarButtonAl = _ref.calendarButtonAltText,
      calendarButtonAltText = _ref$calendarButtonAl === void 0 ? _constants.defaultPopupDateRangePickerProps.calendarButtonAltText : _ref$calendarButtonAl,
      _ref$renderPopupConte = _ref.renderPopupContent,
      renderPopupContent = _ref$renderPopupConte === void 0 ? _constants.defaultPopupDateRangePickerProps.renderPopupContent : _ref$renderPopupConte,
      _ref$shouldCloseOnDat = _ref.shouldCloseOnDateSelection,
      shouldCloseOnDateSelection = _ref$shouldCloseOnDat === void 0 ? _constants.defaultPopupDateRangePickerProps.shouldCloseOnDateSelection : _ref$shouldCloseOnDat,
      _ref$collapsedTitleTe = _ref.collapsedTitleText,
      collapsedTitleText = _ref$collapsedTitleTe === void 0 ? _constants.defaultPopupDateRangePickerProps.collapsedTitleText : _ref$collapsedTitleTe,
      _ref$collapsedCloseBu = _ref.collapsedCloseButtonAltText,
      collapsedCloseButtonAltText = _ref$collapsedCloseBu === void 0 ? _constants.defaultPopupDateRangePickerProps.collapsedCloseButtonAltText : _ref$collapsedCloseBu,
      _ref$ariaLabelsForSel = _ref.ariaLabelsForSelectedDate,
      ariaLabelsForSelectedDate = _ref$ariaLabelsForSel === void 0 ? _constants.defaultPopupDateRangePickerProps.ariaLabelsForSelectedDate : _ref$ariaLabelsForSel,
      clearButtonAltText = _ref.clearButtonAltText,
      datePickerProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var initialStartValue = startValue !== undefined ? startValue : defaultStartValue;
  var initialEndValue = endValue !== undefined ? endValue : defaultEndValue;

  var _useState = (0, _react.useState)(initialStartValue),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      stateStartValue = _useState2[0],
      setStateStartValue = _useState2[1];

  var _useState3 = (0, _react.useState)(initialEndValue),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      stateEndValue = _useState4[0],
      setStateEndValue = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      hasStartError = _useState6[0],
      setHasStartError = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      hasEndError = _useState8[0],
      setHasEndError = _useState8[1];

  var startInputRef = (0, _react.useRef)(null);
  var endInputRef = (0, _react.useRef)(null);
  var selectedStartDate = startValue !== undefined ? startValue : stateStartValue;
  var selectedEndDate = endValue !== undefined ? endValue : stateEndValue;
  var uniqueId = id || (0, _utils.getUniqueId)('popup-datepicker');
  var selectedDaysTotalId = "".concat(uniqueId, "-selected-days-total"); // calculate the number of days within selected range

  var selectedDays = (0, _react.useMemo)(function () {
    if (!stateStartValue || !stateEndValue) {
      return;
    }

    var startDate = new Date(stateStartValue);
    var endDate = new Date(stateEndValue);
    return (0, _utils2.getNumDaysInRange)(startDate, endDate) + 1;
  }, [stateStartValue, stateEndValue]);

  var handleValuesChange = function handleValuesChange(startValue, endValue, closePopup) {
    setStateStartValue(startValue);
    setStateEndValue(endValue);
    !!onChange && onChange(startValue, endValue);

    if (shouldCloseOnDateSelection && !!closePopup) {
      // close both start and end date inputs on date selection
      closePopup();
    }
  };

  var handleStartChange = function handleStartChange(startValue) {
    setHasStartError(false);
    var endValue = selectedEndDate;
    var endDate = (0, _utils2.stringToDate)(endValue);
    var startDate = (0, _utils2.stringToDate)(startValue);

    if (endDate && startDate && startDate > endDate) {
      endValue = '';
    }

    handleValuesChange(startValue, endValue);
  };

  var handleEndChange = function handleEndChange(endValue) {
    setHasEndError(false);
    handleValuesChange(selectedStartDate, endValue);
  };

  var handleSetStartError = function handleSetStartError() {
    setHasStartError(true);
  };

  var handleSetEndError = function handleSetEndError() {
    setHasEndError(true);
  };

  var dataTestProps = (0, _utils.pick)(datePickerProps, _utils.dataTestKeys);
  var viewport = (0, _responsive.useBreakpoints)();
  var flexDirection = layout || (viewport.matches.s ? 'column' : 'row');
  var datePickerContextValue = {
    ariaLabelsForSelectedDate: ariaLabelsForSelectedDate,
    calendarButtonAltText: calendarButtonAltText,
    clearButtonAltText: clearButtonAltText,
    collapsedCloseButtonAltText: collapsedCloseButtonAltText,
    collapsedTitleText: collapsedTitleText,
    dateMarkerLegend: dateMarkerLegend,
    datePickerProps: datePickerProps,
    disabled: disabled,
    flexDirection: flexDirection,
    handleValuesChange: handleValuesChange,
    hasStartError: hasStartError,
    hasEndError: hasEndError,
    popoverProps: popoverProps,
    renderPopupContent: renderPopupContent,
    showSelectedDaysText: showSelectedDaysText,
    selectedDays: selectedDays,
    selectedDaysTotalId: selectedDaysTotalId,
    selectedStartDate: selectedStartDate,
    selectedEndDate: selectedEndDate,
    setHasStartError: setHasStartError,
    setHasEndError: setHasEndError
  };
  return (0, _core.jsx)(_helperComponents.PopupDateRangePickerFieldset, dataTestProps, labelText && (0, _core.jsx)(_helperComponents.PopupDateRangePickerLegend, null, labelText), (0, _core.jsx)(_helperComponents.PopupDateRangePickerWrapper, null, (0, _core.jsx)(_layout.Flex, {
    flexDirection: flexDirection,
    gridGap: "S300"
  }, (0, _core.jsx)(_PopupDatePickerContext.PopupDatePickerContext.Provider, {
    value: datePickerContextValue
  }, (0, _core.jsx)(_DatePickerGroup.default, {
    handleChange: handleStartChange,
    handleError: handleSetStartError,
    htmlFor: "".concat(uniqueId, "-start"),
    inputProps: startDateInputProps,
    inputRef: startInputRef,
    inputRole: _interfaces.DateInputRole.StartDate,
    inputFooter: startDateInputFooter,
    labelText: startDateLabelText,
    name: !!name ? "".concat(name, "-start") : undefined,
    value: selectedStartDate
  }), (0, _core.jsx)(_DatePickerGroup.default, {
    handleChange: handleEndChange,
    handleError: handleSetEndError,
    htmlFor: "".concat(uniqueId, "-end"),
    inputProps: endDateInputProps,
    inputRef: endInputRef,
    inputRole: _interfaces.DateInputRole.EndDate,
    inputFooter: endDateInputFooter,
    labelText: endDateLabelText,
    name: !!name ? "".concat(name, "-end") : undefined,
    value: selectedEndDate
  }))), showSelectedDaysText && selectedDays && (0, _core.jsx)(_text.Text, {
    id: selectedDaysTotalId,
    fontSize: "T100",
    color: "neutral70"
  }, getSelectedDaysText(selectedDays))));
};

var PopupDateRangePickerWithDocs = (0, _stencilReactDesc.describe)(PopupDateRangePickerWithoutDocs).description('Date range picker shown in a popup.');
PopupDateRangePickerWithDocs.propTypes = _objectSpread(_objectSpread(_objectSpread({}, _propTypes.basePopupDatePickerPropTypes), _propTypes2.dateRangePickerPropTypes), {}, {
  startDateLabelText: _stencilReactDesc.PropTypes.string.description('Label for the start date input field.'),
  endDateLabelText: _stencilReactDesc.PropTypes.string.description('Label for the end date input field.'),
  startDateInputProps: _stencilReactDesc.PropTypes.shape(_propTypes2.popupDateRangePickerInputPropTypes).description('Props forwarded to the input field for the start date.'),
  endDateInputProps: _stencilReactDesc.PropTypes.shape(_propTypes2.popupDateRangePickerInputPropTypes).description('Props forwarded to the input field for the end date.'),
  startDateInputFooter: _stencilReactDesc.PropTypes.node.description('Input footer to display below the input field for the start date.'),
  endDateInputFooter: _stencilReactDesc.PropTypes.node.description('Input footer to display below the input field for the end date.'),
  layout: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.DatePickerLayout)).description('Layout of the two input fields in relation to one another.'),
  showSelectedDaysText: _stencilReactDesc.PropTypes.bool.description('Indicates whether the selected number of days within the range should display.'),
  getSelectedDaysText: _stencilReactDesc.PropTypes.func.description('Function to determine how to render the selected number of days within the range.').format("(days: number) => string")
});
var PopupDateRangePicker = (0, _utils.withTestAttributes)({
  component: 'StencilPopupDateRangePicker'
})(PopupDateRangePickerWithDocs);
PopupDateRangePicker.defaultProps = _objectSpread({}, _constants.defaultPopupDateRangePickerProps);
PopupDateRangePicker.displayName = 'PopupDateRangePicker';
var _default = PopupDateRangePicker;
exports.default = _default;